const getColour = (CHARTS, category) => {
  switch (category) {
    case 0:
      return CHARTS.trafficLightColours.red
    case 1:
      return CHARTS.trafficLightColours.amber
    case 2:
      return CHARTS.trafficLightColours.green
    default:
      break
  }
}

export const getStackedRootSeries = (CHARTS, data, t) => {
  const root = []

  // For each root location
  data.forEach((d) => {
    const objects = d.drilldownObjects.concat(d.nonDrilldownObjects)
    const groupedByCategory = groupByArray(objects, "category")

    const rootName = d.name

    groupedByCategory.forEach((c) => {
      // We want one of these per category
      const obj = {
        name: t(rootName),
        data: [],
        index: c.key,
      }

      c.values.forEach((v) => {
        const drillObj = {
          color: getColour(CHARTS, v.category),
          count: v.count,
          name: t(v.name),
          stackCategory: v.category,
          employeeTotal: v.employeeTotal, // This should sum of name/categories
        }

        if (v.count < 1) {
          drillObj.visible = false
        }

        drillObj.drilldown = d.id

        // If has Y property is from drilldownObjects collection
        if (v.y) {
          drillObj.y = v.y
        } else {
          drillObj.y = v.data
        }

        obj.data.push(drillObj)
      })

      obj.data.sort((a, b) => (a.stackCategory < b.stackCategory) - (b.stackCategory < a.stackCategory))

      // Add location/category series
      root.push(obj)
    })
  })

  return root
}

const groupByArray = (xs, key) => {
  return xs.reduce((rv, x) => {
    const v = key instanceof Function ? key(x) : x[key]
    const el = rv.find(r => r && r.key === v)
    if (el) {
      el.values.push(x)
    } else {
      rv.push({ key: v, values: [x] })
    }
    return rv
  }, [])
}

const findParentLocationName = (drilldownSeries, rootSeries, locationId) => {
  let location = drilldownSeries.find(x => x.id === locationId)

  if (!location) {
    location = rootSeries.find(x => x.id === locationId)
    return location.drilldownObjects[0].name
  }

  return location.name
}

export const getStackedDrilldownSeries = (CHARTS, drilldownSeries, rootSeries) => {
  const drilldowns = {}

  const groupedByParentLocation = groupByArray(drilldownSeries, "parentIdentifier")

  groupedByParentLocation.forEach((d) => {
    const drilldownParentIdentifier = d.key

    if (!drilldowns[drilldownParentIdentifier]) {
      drilldowns[drilldownParentIdentifier] = []
    }

    const parent = findParentLocationName(drilldownSeries, rootSeries, drilldownParentIdentifier)
    const groupedByCategory = groupByArray(d.values, "category")

    groupedByCategory.forEach((c) => {
      // We want one of these per category
      const obj = {
        name: parent,
        data: [],
        index: c.key,
      }

      c.values.forEach((v) => {
        const drillObj = {
          color: getColour(CHARTS, v.category),
          count: v.totalSent,
          name: v.name,
          stackCategory: v.category,
          y: v.count,
          employeeTotal: v.employeeTotal, // This should sum of name/categories
        }

        if (v.count < 1) {
          drillObj.visible = false
        }

        if (
          (v.drilldownObjects || v.nonDrilldownObjects) &&
          (v.drilldownObjects.length > 0 || v.nonDrilldownObjects.length > 0)
        ) {
          drillObj.drilldown = v.id
        }

        obj.data.push(drillObj)
      })

      obj.data.sort((a, b) => (a.stackCategory < b.stackCategory) - (b.stackCategory < a.stackCategory))

      // Add location/category series
      drilldowns[drilldownParentIdentifier].push(obj)
    })
  })

  return drilldowns
}

export const getDrilldownSeries = (data, t) => {
  const drilldownSeries = []

  data.drilldownSeries.forEach((d) => {
    const drilldown = {
      id: d.id,
      name: t(d.name),
      data: [],
      colorByPoint: true,
    }

    d.drilldownObjects.forEach((ddo) => {
      const drill = {
        name: t(ddo.name),
        y: ddo.y,
        drilldown: ddo.drilldown,
        total: ddo.count,
      }
      drilldown.data.push(drill)
    })

    d.nonDrilldownObjects.forEach((ddo) => {
      const nodrill = {
        name: t(ddo.name),
        y: ddo.data,
        total: ddo.count,
      }
      drilldown.data.push(nodrill)
    })
    drilldownSeries.push(drilldown)
  })

  return drilldownSeries
}

export const getDrillDownRootSeries = (data, t) => {
  const root = []

  data.rootSeries.forEach((r) => {
    const rootSeries = {
      name: t(r.name),
      colorByPoint: true,
      data: [],
    }

    r.drilldownObjects.forEach((ddo) => {
      const drill = {
        name: t(ddo.name),
        y: ddo.y,
        drilldown: ddo.drilldown,
        total: ddo.count,
      }
      rootSeries.data.push(drill)
    })

    r.nonDrilldownObjects.forEach((ddo) => {
      const nodrill = {
        name: t(ddo.name),
        y: ddo.data,
        total: ddo.count,
      }
      rootSeries.data.push(nodrill)
    })

    root.push(rootSeries)
  })

  return root
}



// WEBPACK FOOTER //
// ./src/utils/drilldown-utils.js